import { truncateString } from '../../packages/kiti/utils/helpers/string'
import { useFieldsFromApi } from '../helpers/fields'

export const useFieldsInterpolationsFetcher = (skip, fieldsOrigin, origin, options) => {
  const { group, fetchPolicy } = options || {}
  const { data: fieldsData } = useFieldsFromApi(origin, undefined, { skip, fetchPolicy })
  const fields = fieldsData?.fields || []

  return [
    ...fields?.map(field => ({
      name: truncateString(field.name, 30),
      fullName: field.name,
      id: `{{#find ${fieldsOrigin} field="field_id" operator="eq" value=${field.id}}}{{field_value.value}}{{/find}}`,
      type: field.type,
      group: group || 'Campos adicionais'
    }))
  ]
}
